<template>
  <v-container class="pt-4 rec-page">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="shadowCard rec-card">
          <v-card-title class="text-subtitle-1 font-weight-bold rec-card__title">
            Recomendados
            <v-spacer></v-spacer>
            <v-btn icon small :to="{ name: 'Perfil' }">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row class="rec-resumen mb-2">
              <v-col cols="4" class="py-1">
                <div class="rec-resumen__label">Personas</div>
                <div class="rec-resumen__valor">{{ total }}</div>
              </v-col>
              <v-col cols="4" class="py-1">
                <div class="rec-resumen__label">Ya pagaron</div>
                <div class="rec-resumen__valor">{{ totalPagados }}</div>
              </v-col>
              <v-col cols="4" class="py-1">
                <div class="rec-resumen__label">Descuento</div>
                <div class="rec-resumen__valor">{{ formatearMoneda(totalDescuentoAplicado) }}</div>
              </v-col>
            </v-row>

            <v-alert v-if="error" dense text type="error" class="mb-3">
              {{ error }}
            </v-alert>

            <div v-if="cargar" class="text-center py-6">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>

            <div v-else-if="!items.length" class="text-center grey--text py-6">
              Aún no has recomendado a nadie.
            </div>

            <v-card
              v-for="item in items"
              :key="item.id"
              outlined
              class="rec-item mb-3"
            >
              <v-card-text class="pb-2">
                <div class="d-flex align-start justify-space-between">
                  <div class="rec-item__nombre">{{ item.prospecto }}</div>
                  <v-chip
                    x-small
                    dark
                    :color="item.pagado ? 'green darken-1' : 'grey'"
                    class="ml-2 flex-shrink-0"
                  >
                    {{ item.pagadoTexto }}
                  </v-chip>
                </div>

                <div v-if="item.folioReferido" class="rec-item__meta">
                  <v-icon x-small color="#db0212" class="mr-1">mdi-file-document-outline</v-icon>
                  Folio referido:
                  <strong class="ml-1">{{ item.folioReferido }}</strong>
                </div>
                <div v-if="item.telefono" class="rec-item__meta">
                  <v-icon x-small color="#db0212" class="mr-1">mdi-phone</v-icon>
                  {{ item.telefono }}
                </div>

                <div
                  v-if="item.tieneDetallePago"
                  class="rec-pago mt-3"
                >
                  <div class="rec-pago__titulo">
                    <v-icon small color="#db0212" class="mr-1">mdi-cash-check</v-icon>
                    Detalle del descuento aplicado
                  </div>

                  <div class="rec-pago__fila">
                    <span>Folio de pago</span>
                    <strong>{{ item.folioPago || '—' }}</strong>
                  </div>
                  <div class="rec-pago__fila">
                    <span>Debías pagar</span>
                    <strong>{{ formatearMoneda(item.montoDebia) }}</strong>
                  </div>
                  <div class="rec-pago__fila">
                    <span>Pagaste</span>
                    <strong class="rec-pago__pagado">{{ formatearMoneda(item.montoPagado) }}</strong>
                  </div>
                  <div
                    v-if="item.descuentoAplicado != null && item.descuentoAplicado > 0"
                    class="rec-pago__fila rec-pago__fila--destacada"
                  >
                    <span>Descuento aplicado</span>
                    <strong>{{ formatearMoneda(item.descuentoAplicado) }}</strong>
                  </div>
                </div>

                <div
                  v-else-if="item.descuentoPendiente != null && item.descuentoPendiente > 0"
                  class="rec-pendiente mt-3"
                >
                  Descuento pendiente: <strong>{{ formatearMoneda(item.descuentoPendiente) }}</strong>
                </div>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { sesionReferralDesdeGetters } from '@/referrals/sesion'
import { formatearMoneda, normalizarListaReferidos } from '@/referrals/formato'

export default {
  data () {
    return {
      cargar: false,
      error: '',
      items: [],
      total: 0,
      totalPagados: 0,
      totalDescuentoAplicado: 0,
    }
  },

  computed: {
    ...mapGetters('login', [
      'getLogeadoLMS',
      'getUsuarioLMS',
      'getDatosUsuarioLMS',
      'getEscuela',
    ]),

    sesionReferral () {
      return sesionReferralDesdeGetters({
        logeado: this.getLogeadoLMS,
        usuario: this.getUsuarioLMS,
        datosUsuario: this.getDatosUsuarioLMS,
        escuela: this.getEscuela,
      })
    },
  },

  created () {
    this.cargarLista()
  },

  methods: {
    formatearMoneda,

    cargarLista () {
      if (!this.sesionReferral.ok) {
        this.error = 'Inicia sesión como alumno para ver tus recomendados.'
        return
      }
      this.cargar = true
      this.error = ''
      this.$http.get('api/referrals', {
        params: { id_lms: this.sesionReferral.idLms },
      }).then((response) => {
        const data = normalizarListaReferidos(response.body || response.data || {})
        this.items = data.items
        this.total = data.total
        this.totalPagados = data.totalPagados
        this.totalDescuentoAplicado = data.totalDescuentoAplicado
      }).catch((error) => {
        this.error = (error && error.body && error.body.message)
          || 'No se pudieron cargar tus recomendados.'
      }).finally(() => {
        this.cargar = false
      })
    },
  },
}
</script>

<style scoped>
.rec-card {
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(8px);
}

.rec-card__title {
  color: #1a1a1a;
}

.rec-resumen__label {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}

.rec-resumen__valor {
  font-size: 1.05rem;
  font-weight: 700;
  color: #db0212;
}

.rec-item {
  border-color: #f0d4d4 !important;
  border-radius: 14px !important;
  background: rgba(255, 255, 255, 0.85) !important;
}

.rec-item__nombre {
  font-weight: 700;
  font-size: 1rem;
  color: #1a2b3c;
  line-height: 1.3;
}

.rec-item__meta {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
}

.rec-pago {
  background: rgba(219, 2, 18, 0.06);
  border: 1px solid rgba(219, 2, 18, 0.18);
  border-radius: 12px;
  padding: 10px 12px;
}

.rec-pago__titulo {
  font-size: 12px;
  font-weight: 700;
  color: #db0212;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.rec-pago__fila {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  padding: 4px 0;
}

.rec-pago__fila strong {
  color: #1a2b3c;
  font-weight: 700;
  text-align: right;
}

.rec-pago__fila--destacada {
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px dashed rgba(219, 2, 18, 0.28);
  font-weight: 600;
  color: #b5000d;
}

.rec-pago__pagado {
  color: #2e7d32 !important;
}

.rec-pendiente {
  font-size: 12px;
  color: #e65100;
  background: #fff8e1;
  border-radius: 10px;
  padding: 8px 10px;
}
</style>
